import { useEffect, useRef } from "react";
import { isRequestAbortError } from "../utils/isRequestAbortError";

/**
 * Runs an async function when deps change; aborts the previous run on re-run/unmount.
 * Cancels in-flight axios requests so React 18 Strict Mode does not produce duplicate API calls.
 *
 * @param {(signal: AbortSignal) => void | Promise<void>} fn
 * @param {React.DependencyList} deps
 */
export function useAbortableAsyncEffect(fn, deps) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const controller = new AbortController();
    Promise.resolve(fnRef.current(controller.signal)).catch((err) => {
      if (isRequestAbortError(err)) return;
      console.error(err);
    });
    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- second argument is the dependency list
  }, deps);
}
